/**
 * Epic label scan for Delivery.
 *
 * Keep this file in sync with api/src/services/Accounts/epic-rx-parsing.service.js.
 *
 * An empty value, the text null, or the default pattern below is parsed
 * with that default pattern. A different saved pattern is used as-is.
 * Name groups rxNumber and fillId. pharmacyNCPDPId is optional.
 */

export const DEFAULT_EPIC_SCAN_REGEXP =
  "/^(?:\\\\...|RX.)?(?<rxNumber>[^^]+)\\^(?<pharmacyNCPDPId>[^^]*)(?:\\^[^^]*){3}\\^(?<fillId>[^^]*)/";

const isBlank = (value) => {
  if (value === undefined || value === null) return true;
  const trimmed = String(value).trim();
  return trimmed === "" || trimmed === "undefined" || trimmed === "null";
};

export const hasCustomEpicRegexp = (value) => {
  if (isBlank(value)) return false;
  return String(value).trim() !== DEFAULT_EPIC_SCAN_REGEXP;
};

export const resolveEpicScanRegexp = (value) => {
  if (!hasCustomEpicRegexp(value)) return DEFAULT_EPIC_SCAN_REGEXP;
  return String(value).trim();
};

const parseRegexFromString = (regexString) => {
  const source = String(regexString).trim();
  const wrapped = source.match(/^\/(.*)\/([gimsuy]*)$/);
  if (!wrapped) {
    return new RegExp(source, "i");
  }
  return new RegExp(wrapped[1], wrapped[2]);
};

export const parseEpicScanRegex = (scannedQR, regexString) => {
  if (scannedQR === undefined || scannedQR === null || isBlank(regexString)) {
    return null;
  }
  let regExp;
  try {
    regExp = parseRegexFromString(regexString);
  } catch (error) {
    return null;
  }
  const match = regExp.exec(String(scannedQR));
  if (!match) return null;

  const groups = match.groups || {};
  let rxNumber;
  let fillId;
  let pharmacyNCPDPId;
  if (groups.rxNumber) {
    rxNumber = groups.rxNumber;
    fillId = groups.fillId != null ? groups.fillId : "";
    pharmacyNCPDPId =
      groups.pharmacyNCPDPId != null ? groups.pharmacyNCPDPId : "";
  } else if (match[1]) {
    rxNumber = match[1];
    fillId = match[2] != null ? match[2] : "";
    pharmacyNCPDPId = match[3] != null ? match[3] : "";
  } else {
    return null;
  }

  rxNumber = String(rxNumber).trim();
  if (!rxNumber) return null;

  return {
    prescriptionNumber: [rxNumber],
    fillId: String(fillId).trim(),
    pharmacyNCPDPId: String(pharmacyNCPDPId).trim(),
    is_coreFlex: false,
  };
};



// WEBPACK FOOTER //
// ./src/utils/epicRxParsing.js